import React from 'react';
import { connect } from "react-redux";
import { getEmployeList, addEmploye, editEmploye, deleteEmploye } from "../../services/admin/action";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DeleteModel from '../common/Model/deleteModel';
import Pagination from "../common/pagination"
import { onlyAlphabets, onlyNumbers} from "../common/keyValidation"

class EmployeSection extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            userType: "",
            popupAdd: false,
            access_token: "",
            employList: [],
            firstName: "",
            lastName: "",
            emailId: "",
            mobileNo: "",
            password: "",
            dateOfBirth: "",
            role: "",
            editStatus: false,
            id: "",
            openPopUp: false,
            openPopUpDel: false,
            empId: "",
            errors: {
                firstName: "",
                lastName: "",
                emailId: "",
                mobileNo: "",
                password: "",
                dateOfBirth: "",
                role: ""
            },
            formValid: false,
            firstNameValid: false,
            lastNameValid: false,
            emailIdValid: false,
            mobileNoValid: false,
            passwordValid: false,
            dateOfBirthValid: false,
            roleValid: false,
            pageOfItems: [],
            disableEmail: false,


        }
    }

    componentDidMount() {
        let access_token = this.props.loginDetails;
        let userType = this.props.profileDetails.commonUser.userType


        this.setState({
            access_token,
            userType
        })

        this.props.getEmployeList(access_token);

    }
    componentWillReceiveProps = nextProps => {
        const {
            firstName,
            lastName,
            emailId,
            password,
            mobileNo,
            dateOfBirth,
            role
        } = this.state;

        let data = nextProps.getEmployListDetails.employeeList;
        document.body.classList.remove('modal-open');

        this.setState({
            employList: data,
            popupAdd: false,
            firstName,
            lastName,
            emailId,
            password,
            mobileNo,
            dateOfBirth,
            role

        })
    }

    validateField(fieldName, value) {
        const {
            errors,
            firstNameValid,
            lastNameValid,
            emailIdValid,
            mobileNoValid,
            passwordValid,
             roleValid,

        } = this.state;
        let fieldValidationErrors = errors;
        let firstNamevalid = firstNameValid;
        let lastNamevalid = lastNameValid;
        let emailIdvalid = emailIdValid;
        let passwordvalid = passwordValid;
         let mobileNovalid = mobileNoValid;
        let rolevalid = roleValid;

        switch (fieldName) {

            case "firstName":
                firstNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors.firstName = firstNamevalid
                    ? ""
                    : "First Name should be 3 to 20 characters";
                break;
            case "lastName":
                lastNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors.lastName = lastNamevalid
                    ? ""
                    : "Last Name should be 3 to 20 characters";
                break;
            case "emailId":
                emailIdvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.emailId = emailIdvalid
                    ? ""
                    : " Please enter valid Email Address";
                break;
            case "mobileNo":
                mobileNovalid = value.match(/^\d{10}$/);
                fieldValidationErrors.mobileNo = mobileNovalid
                    ? ""
                    : " Please enter valid phone number";
                break;
            case "role":
                rolevalid = !(value.length < 1)
                fieldValidationErrors.role = rolevalid
                    ? ""
                    : "Please select the role ";
                break;
            default:
                break;
        }

        this.setState(
            {
                errors: fieldValidationErrors,
                firstNameValid: firstNamevalid,
                lastNameValid: lastNamevalid,
                emailIdValid: emailIdvalid,
                passwordValid: passwordvalid,
                mobileNoValid: mobileNovalid,
                roleValid: rolevalid,
            },
            this.validateForm
        );
    }
    validateForm() {
        const {
            firstNameValid,
            lastNameValid,
            emailIdValid,
            mobileNoValid,
            dateOfBirthValid,
            roleValid,
        } = this.state;
        this.setState({
            formValid:
                firstNameValid &&
                lastNameValid &&
                emailIdValid &&
                mobileNoValid &&
                dateOfBirthValid &&
                roleValid
        });
    }


    handleChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };
    addEmployeModal = (e) => {
        e.preventDefault();
        
        let errorsList = this.state.errors;
        errorsList.firstName = "";
        errorsList.lastName = "";
        errorsList.emailId = "";
        errorsList.mobileNo = "";
        errorsList.password = "";
        errorsList.dateOfBirth = "";
        errorsList.role = "";
        let firstNameValid =  false;
        let lastNameValid =  false;
        let emailIdValid =  false;
        let mobileNoValid =  false;
        let dateOfBirthValid =  false;
        let roleValid =  false;
        this.setState({
            editStatus: false,
            firstName: "",
            lastName: "",
            emailId: "",
            password: "",
            mobileNo: "",
            dateOfBirth: "",
            role: "",
            disableEmail: false,
            firstNameValid,
            dateOfBirthValid,
            lastNameValid,
            emailIdValid,
            mobileNoValid,
            roleValid,
            errors: errorsList,
        }, () => {
            document.body.classList.add('modal-open');
            this.setState({
                popupAdd: true
            })
        })
    }


    addEmployee = (e) => {
        e.preventDefault();
        let {
            // access_token,
            firstName,
            lastName,
            emailId,
            password,
            mobileNo,
            dateOfBirth,
            role
        } = this.state;

        role = role.charAt(0).toUpperCase() + role.slice(1);

        let DOB = moment(dateOfBirth).format('YYYY-MM-DD')

        let Payload = {
            firstName,
            lastName,
            emailId,
            password,
            mobileNo,
            dateOfBirth: DOB,
            role
        }


        let token = { "access_token": this.state.access_token }


        this.props.addEmploye(token, Payload);
    }

    openPop = () => {
        document.body.classList.add('modal-open');
        this.setState({
            openPopUp: true,

        })
    }
    closePop = () => {
         this.setState({
            openPopUp: false,

        })
    }

    updateEmploye = (e) => {
        e.preventDefault();
        let {
            //  access_token,
            firstName,
            lastName,
            emailId,
            mobileNo,
            dateOfBirth,
            role,
            id
        } = this.state;
        let DOB = moment(dateOfBirth).format('YYYY-MM-DD')
        role = role.charAt(0).toUpperCase() + role.slice(1);

        let Payload = {
            firstName,
            lastName,
            emailId,
            mobileNo,
            dateOfBirth: DOB,
            role,
            id
        }
       document.body.classList.remove('modal-open');

        this.setState({
            openPopUp: false,

        })

        let token = { "access_token": this.state.access_token }



        this.props.editEmploye(token, Payload);
    }

    editEmploye = (data) => {



        let errorsList = this.state.errors;
        errorsList.firstName = "";
        errorsList.lastName = "";
        errorsList.emailId = "";
        errorsList.mobileNo = "";
        errorsList.password = "";
        errorsList.dateOfBirth = "";
        errorsList.role = "";
        let firstNameValid = true;
        let lastNameValid = true;
        let emailIdValid = true;
        let mobileNoValid = true;
        let dateOfBirthValid = true;
        let roleValid = true;

        let {
            firstName,
            lastName,
            emailId,
            mobileNo,
            password,
            dateOfBirth,
            role,
            id
        } = data

        let DOB = moment(dateOfBirth).format('YYYY-MM-DD')
        role = role.charAt(0).toUpperCase() + role.slice(1);
        this.setState({
            editStatus: true,
            firstName,
            lastName,
            emailId,
            mobileNo,
            password,
            dateOfBirth: DOB,
            role,
            id,
            firstNameValid,
            dateOfBirthValid,
            lastNameValid,
            emailIdValid,
            mobileNoValid,
            roleValid,
            errors: errorsList,
            disableEmail: true,

        }, () => {
            document.body.classList.add('modal-open');
            this.setState({
                formValid:
                    firstNameValid &&
                    lastNameValid &&
                    emailIdValid &&
                    mobileNoValid &&
                    roleValid,
                popupAdd: true
            })
        })
    }

    handleDateOfBirthChange = (date) => {
        this.setState({
            dateOfBirth: date,
         },()=>{
            let value = this.state.dateOfBirth;
            if(value === null){
              this.setState({
                dateOfBirthValid : false
              })
            }else{
             this.setState({
               dateOfBirthValid : true
             })
           }
          });
    }
    openPopDel = (id) => {
        document.body.classList.add('modal-open');
        this.setState({
            openPopUpDel: true,
            empId: id,
        })

    }
    popupAddOpen=()=>{
        document.body.classList.remove('modal-open');

        this.setState({
            popupAdd : false
        })
    }

    closePopDel = () => {
        document.body.classList.remove('modal-open');
        this.setState({
            openPopUpDel: false
        })
    }

    deleteEmploye = (id) => {
        document.body.classList.remove('modal-open');

        this.setState({
            openPopUpDel: false
        })

        let access_token = this.state.access_token

        this.props.deleteEmploye(access_token, id);
    }

    onChangePage = (pageOfItems) => {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }
   

    render() {
        const {
            firstName,
            lastName,
            emailId,
            password,
            mobileNo,
            dateOfBirth,
            editStatus,
            role,
            errors,
            formValid,
            disableEmail,
            dateOfBirthValid
        } = this.state;

        return (
            <React.Fragment>

                <div className="row tab-pane" id="employee">
                    {/* <div className="row"> */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <button type="button" className="btnDefault" onClick={this.addEmployeModal} >
                            <i className="fa fa-plus" aria-hidden="true"></i>  Add Employee</button>
                        <div className="table-responsive">
                            <table className="table commonTable">
                                <thead>
                                    <tr>
                                        <th>Role</th>
                                        <th>Firstname</th>
                                        <th>Lastname</th>
                                        <th>Email</th>
                                        <th>Mobile</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                {this.state.pageOfItems.length > 0 ?
                                    <tbody>
                                        {this.state.pageOfItems.map((employe, id) => {
                                            return (
                                                <tr key={id}><td>{employe.role}</td>
                                                    <td>{employe.firstName}</td>
                                                    <td>{employe.lastName}</td>
                                                    <td>{employe.emailId}</td>
                                                    <td>{employe.mobileNo}</td>
                                                    <td>
                                                        <a href="javascript:void(0)" className="icon" onClick={() => this.editEmploye(employe)} title="Edit">
                                                            <i className="fa fa-pencil" aria-hidden="true"></i>
                                                        </a>
                                                        {employe.role !== "admin" && 
                                                        <a href="javascript:void(0)" className="icon" onClick={() => this.openPopDel(employe.id)} title="Delete">
                                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                                        </a>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        })}

                                        <DeleteModel header="Delete" text="Are you sure you want to delete?" page="deleteEmployee" status={this.state.openPopUpDel} confirmOkay={() => this.deleteEmploye(this.state.empId)} closePop={this.closePopDel} />

                                    </tbody> : <tr style={{ background: "transparent" }}><td colspan="6" className="text-center"><img alt="" src="images/no-record-found.png" width="180px" style={{ opacity: "0.6" }} /></td></tr>

                                }
                            </table>
                        </div>

                        <Pagination items={this.state.employList} onChangePage={this.onChangePage} />





                    </div>
                </div>


                {/* Add Employee */}
                {this.state.popupAdd &&
                    <div className="addemployee-popup">
                     <form autocomplete="off">
                        <div className="modal fade in" id="myModal" role="dialog"  >
                            <div className="modal-dialog">

                                {/* <!-- Modal content--> */}
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="close" onClick={this.popupAddOpen} >×</button>
                                        <h4 className="modal-title header-title text-center">{editStatus ? "Edit Employee" : "Add Employee"}</h4>
                                    </div>
                                    <div className="modal-body addemployeebody">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <div className="form-group">
                                                    <label>First Name</label>
                                                    <input type="text" onChange={this.handleChange}
                                                        name="firstName" value={firstName} placeholder="First Name*" onKeyPress={onlyAlphabets} className="form-control" />
                                                    <div style={{ color: "red" }}>{errors.firstName}</div>
                                                </div>

                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <div className="form-group">
                                                    <label> Last Name</label>
                                                    <input type="text" onChange={this.handleChange}
                                                        name="lastName" value={lastName} placeholder="Last Name*" className="form-control" />
                                                    <div style={{ color: "red" }}>{errors.lastName}</div>
                                                </div>

                                            </div></div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <div className="form-group">
                                                    <label> Email</label>
                                                    <input type="text" onChange={this.handleChange} disabled={disableEmail}
                                                        name="emailId" value={emailId} placeholder="Email Id*" className="form-control" />
                                                    <div style={{ color: "red" }}>{errors.emailId}</div>
                                                </div>

                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <div className="form-group mobileinput">
                                                    <label> Mobile Number</label>
                                                    <div className="posrelative">
                                                        <input type="text" className="quantity form-control" onChange={this.handleChange}
                                                            onKeyPress={onlyNumbers} maxlength="10"
                                                            name="mobileNo" value={mobileNo} placeholder="Mobile Number*" />
                                                        <div style={{ color: "red" }}>{errors.mobileNo}</div>
                                                        <button type="button" className="mobliecountrycode1">+1</button>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        <div className="row">
                                            {!editStatus &&
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <div className="form-group">
                                                        <label> Password</label>
                                                        <input type="password" onChange={this.handleChange}
                                                            name="password" value={password} placeholder="Password*" className="form-control" />
                                                        <div style={{ color: "red" }}>{errors.password}</div>
                                                    </div>

                                                </div>
                                            }
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <div className="form-group">
                                                    <label> Date of Birth</label>
                                                    <DatePicker selected={dateOfBirth} type="text" className="form-control" placeholderText="DateOfBirth *" name="dateOfBirth"
                                                        onChange={this.handleDateOfBirthChange} peekNextMonth
                                                        maxDate={new Date()}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        autocomplete="false" />
                                                    <span style={{ color: "red" }}>{errors.dateOfBirth}</span>

                                                </div>

                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <div className="form-group">
                                                    <label> Role</label>
                                                    <select className="form-control" id="sel1" name="role" value={role} onChange={this.handleChange}>
                                                        <option>Select Role*</option>
                                                        <option>Employee</option>
                                                        <option>Admin</option>

                                                    </select>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="model-btn text-center mb-3">
                                        {!editStatus &&
                                            <button type="button" disabled={!formValid || !dateOfBirthValid} className="btnDefault" onClick={this.addEmployee} >Add</button>
                                        }
                                        {editStatus &&
                                            <button type="button" disabled={!formValid || !dateOfBirthValid} className="btnDefault" onClick={this.openPop} >Update</button>
                                        }
                                        <button type="button" className="btnDefault" onClick={this.popupAddOpen} >Close</button></div>
                                </div>

                                <DeleteModel header="Edit" text="Are you sure you want to edit?" page="editEmployee" status={this.state.openPopUp} confirmOkay={this.updateEmploye} closePop={this.closePop} />

                            </div>

                        </div>
                   </form>
                    </div>
                }


            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
    message: state.commonReducer.message,
    loginDetails: state.commonReducer.loginDetails,
    getEmployListDetails: state.adminReducer.getEmployListDetails,
    getEmployListStatus: state.adminReducer.getEmployListStatus
});

const mapDispatchToProps = dispatch => ({
    getEmployeList: token => dispatch(getEmployeList(token)),
    addEmploye: (token, Payload, ) => dispatch(addEmploye(token, Payload)),
    editEmploye: (token, Payload, ) => dispatch(editEmploye(token, Payload)),
    deleteEmploye: (token, id, ) => dispatch(deleteEmploye(token, id)),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmployeSection);

